import {ConsultProtocolsParams, ConsultProtocolTypeEnum} from 'domain/usecases';
import {makeGetConsultProtocols} from 'main/factories/usecases/private/consult-protocols';
import {capitalize} from '@mui/material';

export async function getProtocols(params: ConsultProtocolsParams) {
	const {initialDate, finalDate} = params;

	if (!initialDate && !finalDate) {
		return {
			items: [],
			filters: {
				protocolsTypes: [],
				statusTypes: [],
			},
		};
	}

	const {protocolos} = await makeGetConsultProtocols().get(params);

	const protocolsFormatted = protocolos.map(item => ({
		...item,
		statusDescricao: capitalize((item?.statusDescricao ?? '').toLowerCase()),
		tipoProtocolo:
			item.tipoProtocolo === ConsultProtocolTypeEnum.SAC
				? item.tipoProtocolo
				: capitalize(item.tipoProtocolo.toLowerCase()),
	}));

	const protocolsTypes: string[] = [
		...new Set(protocolsFormatted.map(item => item.tipoProtocolo)),
	];

	const statusTypes = new Map<number, string>();

	protocolsFormatted.forEach(item => {
		if (!statusTypes.has(item.status)) {
			statusTypes.set(item.status, item?.statusDescricao ?? '');
		}
	});

	const filters = {
		protocolsTypes,
		statusTypes: Array.from(statusTypes.entries()).map(([statusId, statusDescricao]) => ({
			statusId: statusId.toString(),
			statusDescricao: capitalize(statusDescricao.toLowerCase()),
		})),
	};

	return {
		items: protocolsFormatted,
		filters,
	};
}
